// src/redux/stores/projects/projectSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Définition de l'interface Projet
export interface Projet {
  id: string;
  titre: string;
  categorie: string;
  icon?: string;
  image: string;
  description: string;
  objectif: string;
  participants: string;
  resultats: string;
  longDescription: string;
  dateDebut: Date;
  dateFin: Date;
  responsable: string;
  statut: string;
  impacts?: string[];
  partenaires?: string[];
  code_ecole: string;
  population_ecole: string;
  access: boolean;
  createdBy: string;
  updatedBy?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

// State typé pour tous les projets
interface ProjetState {
  projets: Projet[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: ProjetState = {
  projets: [],
  loading: false,
  error: null
};

// Slice
export const projetSlice = createSlice({
  name: "projets",
  initialState,
  reducers: {
    setProjets(state, action: PayloadAction<Projet[]>) {
      state.projets = action.payload;
      state.loading = false;
      state.error = null;
    },
    addProjet(state, action: PayloadAction<Projet>) {
      state.projets.push(action.payload);
    },
    updateProjet(state, action: PayloadAction<Projet>) {
      const index = state.projets.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.projets[index] = action.payload;
      }
    },
    removeProjet(state, action: PayloadAction<string>) {
      state.projets = state.projets.filter(p => p.id !== action.payload);
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    }
  }
});

// Export des actions
export const { setProjets, addProjet, updateProjet, removeProjet, setLoading, setError } = projetSlice.actions;

// Export du reducer
export default projetSlice.reducer;
